import React, { useEffect, useState } from 'react';
import {
  Dialog,
  Button,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  InputLabel,
  Box
} from '@mui/material';
import Contact from '../../Model/contact';
import { useTranslation } from 'react-i18next';
import { updateContact } from '../../api/contacts';
import '../../pages/Contacts/contacts.css';
import { CustomAlertType } from '../CustomAlert';


interface IModifyContactProperties {
  showModal: boolean;
  hideModal: () => void;
  contact: Contact;
  setShowError: Function;
  setErrorMessage: Function;
  setErrorType: Function;
}

export const ModifyContactProperties = ({
  showModal,
  hideModal,
  contact,
  setShowError,
  setErrorMessage,
  setErrorType
}: IModifyContactProperties) => {
  const { t } = useTranslation();
  const id = contact?.id;
  const [name, setName] = useState(contact.name);
  const [surname, setSurname] = useState(contact.surname);
  const [phone, setPhone] = useState(contact.phone);

  useEffect(() => {
    setName(contact?.name);
    setSurname(contact?.surname);
    setPhone(contact?.phone);
  }, [contact]);

  const save = async () => {
    if (!id) {
      console.log('NO ID');
      hideModal();
      setShowError(true);
      setErrorType(CustomAlertType.ERROR);
      setErrorMessage(t('NOT_SAVED_DATA'));
      return;
    }

    try {
      const result = await updateContact(id, name, surname, phone);
      if (result.data?.success) {
        hideModal();
        setShowError(true);
        setErrorType(CustomAlertType.INFO);
        setErrorMessage(t('SAVED_DATA'));
      }
    } catch (err: any) {
      hideModal();
      setShowError(true);
      setErrorType(CustomAlertType.ERROR);
      setErrorMessage(t('NOT_SAVED_DATA'));
    }
  };

  const changeNameValue = (nameValue: string) => {
    setName(nameValue);
  };
  const changeSurnameValue = (surnameValue: string) => {
    setSurname(surnameValue);
  };
  const changePhoneValue = (phoneValue: string) => {
    setPhone(phoneValue);
  };
  return (
    <>
      <Dialog className='dialog' fullWidth open={showModal} onClose={hideModal}>
        <DialogTitle className="dialogTitle">
          {t('MODIFY_CONTACT_PROPERTIES')}
        </DialogTitle>
        <DialogContent style={{ width: 400 }}>
          <Box sx={{ height: 20 }}></Box>
          <InputLabel>{t('NAME')}</InputLabel>
          <TextField
            sx={{
              '& legend': { display: 'none' },
              '& fieldset': { top: 0 }
            }}
            size="small"
            required
            fullWidth
            id="name"
            defaultValue={contact?.name}
            onChange={(event: any) => changeNameValue(event.target.value)}
          />
          <Box sx={{ height: 20 }}></Box>
          <InputLabel>{t('SURNAME')}</InputLabel>
          <TextField
            size="small"
            sx={{
              '& legend': { display: 'none' },
              '& fieldset': { top: 0 }
            }}
            required
            fullWidth
            id="surname"
            defaultValue={contact?.surname}
            onChange={(event: any) => changeSurnameValue(event.target.value)}
          />
          <Box sx={{ height: 20 }}></Box>
          <InputLabel>{t('PHONE')}</InputLabel>
          <TextField
            size="small"
            sx={{
              '& legend': { display: 'none' },
              '& fieldset': { top: 0 }
            }}
            required
            fullWidth
            id="phone"
            defaultValue={contact?.phone}
            onChange={(event: any) => changePhoneValue(event.target.value)}
          />
        </DialogContent>
        <DialogActions style={{ marginRight: 15, marginBottom: 15 }}>
          <Button variant="contained" onClick={() => save()}>
            {t('SAVE')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
